var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgError = function SvgError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none",
    viewBox: "0 0 28 28"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14 .028a13.96 13.96 0 0 0-9.879 4.093A13.96 13.96 0 0 0 .028 14c0 3.706 1.472 7.259 4.093 9.879a13.96 13.96 0 0 0 9.88 4.092c3.705 0 7.258-1.47 9.878-4.092a13.96 13.96 0 0 0 4.093-9.88c0-3.706-1.471-7.259-4.093-9.878A13.96 13.96 0 0 0 14 .028m0 25.48a11.509 11.509 0 0 1 0-23.016A11.51 11.51 0 0 1 25.508 14a11.5 11.5 0 0 1-3.368 8.139A11.5 11.5 0 0 1 14 25.507Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m18.356 7.894 1.75 1.75L15.74 14l4.365 4.355-1.75 1.75L14 15.741l-4.355 4.364-1.75-1.75L12.259 14 7.895 9.644l1.75-1.75L14 12.26z"
  })));
};
export default SvgError;